import * as React from 'react'
import ingredients from '../../data/ingredients.en'
import messages from '../../messages/en'
import KVTitle from '../../assets/titles/For_Your_Assurance.png'
import IngredientsPolicy from '../../assets/titles/Ingredients_Policy.png'
import OftenAskedIngredients from '../../assets/titles/Often_Asked_Ingredie.png'
import IngredientsIndex from '../../components/ingredients/IngredientsIndex'
import { Language } from '../../Language'
import { FontsContext } from '../../context'
import { fonts } from '../../constants'

export default () => {
  return (
    <FontsContext.Provider value={fonts.en}>
      <IngredientsIndex
        ingredients={ingredients}
        messages={messages}
        titles={{ KVTitle, IngredientsPolicy, OftenAskedIngredients }}
        language={Language.EN}
      />
    </FontsContext.Provider>
  )
}
